// xux-grid actions
export enum XUX_GRID_ACTIONS {
  ACTION_BUTTON_CLICKED = 'ACTION_BUTTON_CLICKED',
  ROW_DOUBLE_CLICKED = 'ROW_DOUBLE_CLICKED',
  ROW_CLICKED = 'ROW_CLICKED',
  ROW_SELECTION_CHANGED = 'ROW_SELECTION_CHANGED',
  ROW_SELECTED = 'ROW_SELECTED',
  ALL_ROWS_SELECTED = 'ALL_ROWS_SELECTED',
  EVENT_ROW_SELECTED = 'EVENT_ROW_SELECTED',
  COLUMN_SELECTION_CHANGED = 'COLUMN_SELECTION_CHANGED',
  ROW_DATA_CHANGED = 'ROW_DATA_CHANGED',
  ITEM_DATA_CHANGED = 'ITEM_DATA_CHANGED',
  ITEM_ORDER_CHANGED = 'ITEM_ORDER_CHANGED',
  ITEMS_DATA_CHANGED = 'ITEMS_DATA_CHANGED',
  ITEMS_ARRAY_CHANGED = 'ITEMS_ARRAY_CHANGED',
  PINNED_TOP_ITEM_DATA_CHANGED = 'PINNED_TOP_ITEM_DATA_CHANGED',
  CURRENT_PAGE_CHANGED = 'CURRENT_PAGE_CHANGED',
  PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED',
  QUICK_FILTER_CHANGED = 'QUICK_FILTER_CHANGED',
  FILTER_MODEL_CHANGED = 'FILTER_MODEL_CHANGED',
  SORT_MODEL_CHANGED = 'SORT_MODEL_CHANGED',
  GRID_READY = 'GRID_READY',
  LIST_VIEW_REMOVE = 'LIST_VIEW_REMOVE',
  LIST_VIEW_SAVE = 'LIST_VIEW_SAVE',
  LIST_VIEW_RESET = 'LIST_VIEW_RESET',
  LIST_VIEW_LOAD = 'LIST_VIEW_LOAD',
  LIST_GROUP_EXPANDED = 'LIST_GROUP_EXPANDED',
  LIST_GROUP_COLLAPSED = 'LIST_GROUP_COLLAPSED',
  LIST_GROUP_EXPAND_ALL = 'LIST_GROUP_EXPAND_ALL',
  LIST_GROUP_COLLAPSE_ALL = 'LIST_GROUP_COLLAPSE_ALL',
  ROW_HEIGHT_CHANGED = 'ROW_HEIGHT_CHANGED',
  REMOVE_ROW = 'REMOVE_ROW',
  ADD_ROW = 'ADD_ROW',
  FILTER_CHANGES = 'FILTER_CHANGES',
}
